module.exports = __webpack_public_path__ + "0af5d249/img/pdf-icon.79f04a36.svg";